import React from 'react';
import { Compass, Smartphone, Monitor, Globe } from 'lucide-react';

export default function DiscoveryCard({ referrers = [], countries = [], devices = [] }) {
  return (
    <div className="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 p-4 sm:p-5 shadow-sm space-y-4">
      {/* Referrers */}
      <div>
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-semibold text-slate-900 dark:text-white flex items-center gap-1.5">
            <Compass className="w-4 h-4 text-emerald-500" />
            Inbound Referrers & Search
          </h3>
        </div>
        {referrers.length === 0 ? (
          <p className="text-xs text-slate-400 py-2">No referrer data in this timeframe.</p>
        ) : (
          <div className="space-y-1.5">
            {referrers.slice(0, 5).map((r, idx) => (
              <div key={idx} className="flex items-center justify-between text-xs py-1">
                <span className="font-mono text-slate-700 dark:text-slate-300 truncate max-w-[200px] sm:max-w-[280px]">
                  {r.ref_raw || 'Direct'}
                </span>
                <span className="font-mono font-bold text-slate-900 dark:text-white tabular-nums">
                  {Number(r.hits || 0).toLocaleString()}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="border-t border-slate-100 dark:border-slate-800 pt-3 grid grid-cols-2 gap-3 text-xs">
        {/* Top Countries */}
        <div>
          <span className="font-semibold text-slate-800 dark:text-slate-200 flex items-center gap-1 mb-1.5">
            <Globe className="w-3.5 h-3.5 text-blue-500" />
            Countries
          </span>
          <div className="space-y-1">
            {countries.slice(0, 4).map((c, idx) => (
              <div key={idx} className="flex items-center justify-between text-[11px]">
                <span className="font-mono text-slate-600 dark:text-slate-400">{c.country || 'XX'}</span>
                <span className="font-mono text-slate-900 dark:text-white tabular-nums">{c.count}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Devices */}
        <div>
          <span className="font-semibold text-slate-800 dark:text-slate-200 flex items-center gap-1 mb-1.5">
            <Smartphone className="w-3.5 h-3.5 text-purple-500" />
            Devices
          </span>
          <div className="space-y-1">
            {devices.slice(0, 4).map((d, idx) => (
              <div key={idx} className="flex items-center justify-between text-[11px]">
                <span className="font-mono text-slate-600 dark:text-slate-400 capitalize">{d.device_type || 'other'}</span>
                <span className="font-mono text-slate-900 dark:text-white tabular-nums">{d.count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
